(function () {
  var labelMap = {
  'echelle_intensite descending': 'Intensité (décroissante)',
  'echelle_intensite ascending': 'Intensité (croissante)'
  };

  function relabelSortOptions() {
    document.querySelectorAll('#sortButton').forEach(function (el) {
      Object.keys(labelMap).forEach(function (oldLabel) {
        if (el.textContent.indexOf(oldLabel) !== -1) {
          el.textContent = el.textContent.split(oldLabel).join(labelMap[oldLabel]);
        }
      });
    });
  }

  relabelSortOptions();

  new MutationObserver(relabelSortOptions).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('#sortButton')) {
      setTimeout(relabelSortOptions, 0);
      setTimeout(relabelSortOptions, 50);
      setTimeout(relabelSortOptions, 200);
    }
  });
})();